import { authFetch } from 'auth/utils.ts';
import { saveAs } from 'file-saver';

export const getFileNameFromContentDispositionHeader = (headerValue: string | null) => {
  if (!headerValue) {
    return '';
  }

  const filenamePropertyString = headerValue.split(';').find((n) => n.includes('filename='));
  if (!filenamePropertyString) {
    return '';
  }

  return filenamePropertyString.replace('filename=', '').trim().replaceAll('"', '');
};

export const downloadFile = async (filePath: string) => {
  const fileResponse = await authFetch(filePath);

  const filename = getFileNameFromContentDispositionHeader(
    fileResponse.headers.get('Content-Disposition'),
  );

  const blob = await fileResponse.blob();

  saveAs(blob, filename);
};
